import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Printer } from 'lucide-react';

/**
 * Modal para capturar o nome de quem RECEBE o pagamento (assinatura do recibo).
 *
 * Props:
 *  - open: boolean
 *  - defaultNome: string (sugestão inicial - normalmente o nome do proprietário/empresa)
 *  - onCancel: () => void
 *  - onConfirm: (nome: string) => void
 */
export default function ReciboNomeModal({ open, defaultNome = '', onCancel, onConfirm }) {
  const [nome, setNome] = useState(defaultNome || '');

  useEffect(() => {
    if (open) setNome(defaultNome || '');
  }, [open, defaultNome]);

  const handleConfirm = () => {
    const v = (nome || '').trim();
    onConfirm(v);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleConfirm();
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onCancel && onCancel(); }}>
      <DialogContent className="max-w-md" data-testid="dialog-recibo-nome">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Printer className="w-4 h-4 text-cyan-600" />
            Gerar Recibo
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Quem está recebendo o pagamento? Este nome aparecerá na linha de assinatura do recibo.
          </p>
          <div>
            <Label htmlFor="recibo-nome">Digite o nome de quem recebe</Label>
            <Input
              id="recibo-nome"
              autoFocus
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Ex: João da Silva"
              data-testid="input-recibo-nome"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>Cancelar</Button>
          <Button onClick={handleConfirm} data-testid="btn-confirmar-recibo">
            <Printer className="w-4 h-4 mr-2" /> Imprimir recibo
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
